import { type QueryHookOptions, gql, useQuery } from "@apollo/client";

const HAS_PROPERTY_LISTINGS_QUERY = gql`
  query PropertyListings($filter: PropertyListingFilters) {
    propertyListings(filter: $filter) {
      id
    }
  }
`;

interface HasPropertyListingsData {
  propertyListings: {
    id: string;
  }[];
}

interface HasPropertyListingsVariables {
  filter: {
    listingAgentIds: string[];
  };
}

const useHasPropertyListingsQuery = (
  options?: QueryHookOptions<HasPropertyListingsData, HasPropertyListingsVariables>,
) => {
  return useQuery<HasPropertyListingsData, HasPropertyListingsVariables>(
    HAS_PROPERTY_LISTINGS_QUERY,
    options,
  );
};

export type { HasPropertyListingsVariables, HasPropertyListingsData };
export { useHasPropertyListingsQuery };
